// ── Supported Coin Slugs, Symbols, and Display Names ──────────────────────────

export const SLUG_TO_SYMBOL_MAP = {
  // Bitcoin & PayBito Bitcoin aliases
  bitcoin: "BTC",
  btc: "BTC",
  BTC: "BTC",
  bic: "BTC",
  BIC: "BTC",

  // PayBito native token
  payb: "PAYB",
  PAYB: "PAYB",
  paybito: "PAYB",

  // PancakeSwap
  pancakeswap: "CAKE",
  cake: "CAKE",
  CAKE: "CAKE",

  // Major cryptos
  ethereum: "ETH",
  eth: "ETH",
  ETH: "ETH",
  solana: "SOL",
  sol: "SOL",
  SOL: "SOL",
  binancecoin: "BNB",
  bnb: "BNB",
  BNB: "BNB",
  ripple: "XRP",
  xrp: "XRP",
  XRP: "XRP",
  dogecoin: "DOGE",
  doge: "DOGE",
  DOGE: "DOGE",
  cardano: "ADA",
  ada: "ADA",
  ADA: "ADA",
  avalanche: "AVAX",
  avax: "AVAX",
  AVAX: "AVAX",
  chainlink: "LINK",
  link: "LINK",
  LINK: "LINK",
  tether: "USDT",
  usdt: "USDT",
  USDT: "USDT",
  tron: "TRX",
  trx: "TRX",
  TRX: "TRX",
  polkadot: "DOT",
  dot: "DOT",
  DOT: "DOT",
  polygon: "MATIC",
  matic: "MATIC",
  MATIC: "MATIC",
  pol: "POL",
  POL: "POL",
  shiba: "SHIB",
  "shiba-inu": "SHIB",
  shib: "SHIB",
  SHIB: "SHIB",
  litecoin: "LTC",
  ltc: "LTC",
  LTC: "LTC",
  vechain: "VET",
  vet: "VET",
  VET: "VET",
  yearn: "YFI",
  "yearn-finance": "YFI",
  yfi: "YFI",
  YFI: "YFI",
  wrappedbitcoin: "WBTC",
  "wrapped-bitcoin": "WBTC",
  wbtc: "WBTC",
  WBTC: "WBTC",
  uniswap: "UNI",
  uni: "UNI",
  UNI: "UNI",
  cosmos: "ATOM",
  atom: "ATOM",
  ATOM: "ATOM",
  stellar: "XLM",
  xlm: "XLM",
  XLM: "XLM",
  monero: "XMR",
  xmr: "XMR",
  XMR: "XMR",
  near: "NEAR",
  "near-protocol": "NEAR",
  NEAR: "NEAR",
  pepe: "PEPE",
  PEPE: "PEPE",
  sui: "SUI",
  SUI: "SUI",
  aptos: "APT",
  apt: "APT",
  APT: "APT",
  arbitrum: "ARB",
  arb: "ARB",
  ARB: "ARB",
  optimism: "OP",
  op: "OP",
  OP: "OP",
  fantom: "FTM",
  ftm: "FTM",
  FTM: "FTM",
  injective: "INJ",
  inj: "INJ",
  INJ: "INJ",
  kaspa: "KAS",
  kas: "KAS",
  KAS: "KAS",
  render: "RENDER",
  rndr: "RENDER",
  RENDER: "RENDER",
  RNDR: "RENDER",
  algorand: "ALGO",
  algo: "ALGO",
  ALGO: "ALGO",
  filecoin: "FIL",
  fil: "FIL",
  FIL: "FIL",
  aave: "AAVE",
  AAVE: "AAVE",
  maker: "MKR",
  mkr: "MKR",
  MKR: "MKR",
  quant: "QNT",
  qnt: "QNT",
  QNT: "QNT",
  thegraph: "GRT",
  grt: "GRT",
  GRT: "GRT",
  fetchai: "FET",
  fet: "FET",
  FET: "FET",
  immutable: "IMX",
  imx: "IMX",
  IMX: "IMX",
  flow: "FLOW",
  FLOW: "FLOW",
  tezos: "XTZ",
  xtz: "XTZ",
  XTZ: "XTZ",
  eos: "EOS",
  EOS: "EOS",
  decentraland: "MANA",
  mana: "MANA",
  MANA: "MANA",
  sandbox: "SAND",
  "the-sandbox": "SAND",
  sand: "SAND",
  SAND: "SAND",
  axie: "AXS",
  "axie-infinity": "AXS",
  axs: "AXS",
  AXS: "AXS",
  chiliz: "CHZ",
  chz: "CHZ",
  CHZ: "CHZ",
  theta: "THETA",
  THETA: "THETA",
  gala: "GALA",
  GALA: "GALA",
  bitcoincash: "BCH",
  "bitcoin-cash": "BCH",
  bch: "BCH",
  BCH: "BCH",
  ethereumclassic: "ETC",
  "ethereum-classic": "ETC",
  etc: "ETC",
  ETC: "ETC",
  hedera: "HBAR",
  hbar: "HBAR",
  HBAR: "HBAR",
  lido: "LDO",
  ldo: "LDO",
  LDO: "LDO",
  sei: "SEI",
  SEI: "SEI",
  celestia: "TIA",
  tia: "TIA",
  TIA: "TIA",
  floki: "FLOKI",
  FLOKI: "FLOKI",
  bonk: "BONK",
  BONK: "BONK",
  starknet: "STRK",
  strk: "STRK",
  STRK: "STRK",
  jupiter: "JUP",
  jup: "JUP",
  JUP: "JUP",
  worldcoin: "WLD",
  wld: "WLD",
  WLD: "WLD",
  pendle: "PENDLE",
  PENDLE: "PENDLE",
  ronin: "RON",
  ron: "RON",
  RON: "RON",
  pyth: "PYTH",
  PYTH: "PYTH",
  toncoin: "TON",
  ton: "TON",
  TON: "TON",
  notcoin: "NOT",
  not: "NOT",
  NOT: "NOT",
  dogwifhat: "WIF",
  wif: "WIF",
  WIF: "WIF",
  biconomy: "BICO",
  bico: "BICO",
  BICO: "BICO",
};

export const KNOWN_NAMES = {
  BTC: "Bitcoin",
  BIC: "Bitcoin",
  PAYB: "PayBito",
  ETH: "Ethereum",
  SOL: "Solana",
  BNB: "BNB",
  XRP: "XRP",
  DOGE: "Dogecoin",
  ADA: "Cardano",
  AVAX: "Avalanche",
  LINK: "Chainlink",
  USDT: "Tether",
  TRX: "Tron",
  DOT: "Polkadot",
  MATIC: "Polygon",
  POL: "Polygon (POL)",
  SHIB: "Shiba Inu",
  LTC: "Litecoin",
  VET: "VeChain",
  YFI: "yearn.finance",
  WBTC: "Wrapped Bitcoin",
  UNI: "Uniswap",
  ATOM: "Cosmos",
  XLM: "Stellar",
  XMR: "Monero",
  NEAR: "NEAR Protocol",
  PEPE: "Pepe",
  SUI: "Sui",
  APT: "Aptos",
  ARB: "Arbitrum",
  OP: "Optimism",
  FTM: "Fantom",
  INJ: "Injective",
  KAS: "Kaspa",
  RENDER: "Render",
  RNDR: "Render",
  ALGO: "Algorand",
  FIL: "Filecoin",
  AAVE: "Aave",
  MKR: "Maker",
  QNT: "Quant",
  GRT: "The Graph",
  FET: "Fetch.ai",
  IMX: "Immutable",
  FLOW: "Flow",
  XTZ: "Tezos",
  EOS: "EOS",
  MANA: "Decentraland",
  SAND: "The Sandbox",
  AXS: "Axie Infinity",
  CHZ: "Chiliz",
  THETA: "Theta Network",
  GALA: "Gala",
  BCH: "Bitcoin Cash",
  ETC: "Ethereum Classic",
  HBAR: "Hedera",
  LDO: "Lido DAO",
  SEI: "Sei",
  TIA: "Celestia",
  FLOKI: "Floki",
  BONK: "Bonk",
  STRK: "Starknet",
  JUP: "Jupiter",
  WLD: "Worldcoin",
  PENDLE: "Pendle",
  RON: "Ronin",
  PYTH: "Pyth Network",
  CAKE: "PancakeSwap",
  TON: "Toncoin",
  NOT: "Notcoin",
  WIF: "dogwifhat",
  BICO: "Biconomy",
};

export const COIN_SLUG_MAP = {
  BTC: "bitcoin",
  BIC: "bitcoin",
  PAYB: "paybito",
  ETH: "ethereum",
  SOL: "solana",
  BNB: "bnb",
  XRP: "xrp",
  DOGE: "dogecoin",
  ADA: "cardano",
  AVAX: "avalanche",
  LINK: "chainlink",
  USDT: "tether",
  TRX: "tron",
  DOT: "polkadot",
  MATIC: "polygon",
  POL: "polygon",
  SHIB: "shiba-inu",
  LTC: "litecoin",
  BCH: "bitcoin-cash",
  UNI: "uniswap",
  XLM: "stellar",
  ATOM: "cosmos",
  ETC: "ethereum-classic",
  VET: "vechain",
  YFI: "yearn-finance",
  WBTC: "wrapped-bitcoin",
  NEAR: "near",
  PEPE: "pepe",
  SUI: "sui",
  APT: "aptos",
  ARB: "arbitrum",
  OP: "optimism",
  FTM: "fantom",
  INJ: "injective",
  KAS: "kaspa",
  RENDER: "render",
  RNDR: "render",
  ALGO: "algorand",
  FIL: "filecoin",
  AAVE: "aave",
  MKR: "maker",
  QNT: "quant",
  GRT: "thegraph",
  FET: "fetchai",
  IMX: "immutable",
  FLOW: "flow",
  XTZ: "tezos",
  EOS: "eos",
  MANA: "decentraland",
  SAND: "sandbox",
  AXS: "axie",
  CHZ: "chiliz",
  THETA: "theta",
  GALA: "gala",
  HBAR: "hedera",
  LDO: "lido",
  SEI: "sei",
  TIA: "celestia",
  FLOKI: "floki",
  BONK: "bonk",
  STRK: "starknet",
  JUP: "jupiter",
  WLD: "worldcoin",
  PENDLE: "pendle",
  RON: "ronin",
  PYTH: "pyth",
  CAKE: "pancakeswap",
  TON: "toncoin",
  NOT: "notcoin",
  WIF: "dogwifhat",
  BICO: "biconomy",
};

// ── Check if an asset is supported in the Coin Price Overview mapping ─────────
export const isSupportedCoinPriceAsset = (asset) => {
  if (!asset) return false;
  const clean = String(asset).trim();
  const lower = clean.toLowerCase();
  const upper = clean.toUpperCase();

  return Boolean(
    SLUG_TO_SYMBOL_MAP[lower] ||
    SLUG_TO_SYMBOL_MAP[upper] ||
    COIN_SLUG_MAP[upper] ||
    KNOWN_NAMES[upper]
  );
};

// ── Get canonical URL slug for an asset ───────────────────────────────────────
export const getCoinPriceSlug = (asset) => {
  if (!asset) return "bitcoin";
  const clean = String(asset).trim();
  const upper = clean.toUpperCase();
  if (COIN_SLUG_MAP[upper]) {
    return COIN_SLUG_MAP[upper];
  }
  const lower = clean.toLowerCase();
  if (SLUG_TO_SYMBOL_MAP[lower]) {
    const symbol = SLUG_TO_SYMBOL_MAP[lower];
    if (COIN_SLUG_MAP[symbol]) return COIN_SLUG_MAP[symbol];
  }
  return lower;
};

// ── Get user-facing display name for an asset ─────────────────────────────────
export const getCoinPriceDisplayName = (asset) => {
  if (!asset) return "Bitcoin";
  const clean = String(asset).trim();
  const upper = clean.toUpperCase();
  if (KNOWN_NAMES[upper]) return KNOWN_NAMES[upper];
  const lower = clean.toLowerCase();
  if (SLUG_TO_SYMBOL_MAP[lower]) {
    const sym = SLUG_TO_SYMBOL_MAP[lower];
    if (KNOWN_NAMES[sym]) return KNOWN_NAMES[sym];
    return sym;
  }
  return upper;
};

